import React from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import MotorSelect from "./MotorSelect";
import { MotorContact, MotorVehicleType, MotorMakeModel } from "./MotorShared";

const MotorFull = ({ user, setUser, details, setDetails }) => {
  const update = (key) => (value) => setDetails((previous) => ({ ...previous, [key]: value }));
  return (
    <div>
      <MotorContact user={user} setUser={setUser} />
      <MotorVehicleType details={details} setDetails={setDetails} />
      <MotorSelect name="registered" label="Registration number available"
        value={details.has_registration_number} onChange={update("has_registration_number")}
        options={[{ value: "yes", label: "Yes" }, { value: "no", label: "No" }]} />
      <MotorSelect name="finance" label="Lease, loan or hire"
        value={details.has_lease_loan_or_hire} onChange={update("has_lease_loan_or_hire")}
        options={[{ value: "yes", label: "Yes" }, { value: "no", label: "No" }]} />
      <FloatingLabel controlId="motor-value" label="Estimated market value (LKR)*">
        <Form.Control type="number" min="0.01" step="0.01" required
          placeholder="Estimated market value (LKR)*" value={details.estimated_market_value}
          onChange={(event) => update("estimated_market_value")(event.target.value)} />
      </FloatingLabel>
      <MotorSelect name="full-usage" label="Usage" value={details.purpose_of_use}
        onChange={update("purpose_of_use")} options={["Private", "Hiring", "Rent"]} />
      <FloatingLabel controlId="motor-fuel" label="Fuel type*" className="has-content">
        <Form.Select required value={details.fuel_type}
          onChange={(event) => update("fuel_type")(event.target.value)}>
          <option value="">Select fuel type</option>
          {["Petrol", "Diesel", "Hybrid", "Electric", "Other"].map((fuel) => (
            <option key={fuel} value={fuel}>{fuel}</option>
          ))}
        </Form.Select>
      </FloatingLabel>
      <MotorMakeModel details={details} setDetails={setDetails} />
      <FloatingLabel controlId="motor-year" label="Year of manufacture*">
        <Form.Control type="number" min="1900" max={new Date().getFullYear() + 1} step="1" required
          placeholder="Year of manufacture*" value={details.year_of_manufacture}
          onChange={(event) => update("year_of_manufacture")(event.target.value)} />
      </FloatingLabel>
      <FloatingLabel controlId="motor-no-claims" label="No-claims bonus*" className="has-content">
        <Form.Select required value={details.no_claims_bonus_years}
          onChange={(event) => update("no_claims_bonus_years")(event.target.value)}>
          <option value="">Select claim-free years</option>
          <option value="0">None</option>
          {Array.from({ length: 10 }, (_, index) => index + 1).map((years) => (
            <option key={years} value={years}>{years} {years === 1 ? "year" : "years"}</option>
          ))}
        </Form.Select>
      </FloatingLabel>
    </div>
  );
};

export default MotorFull;
